import React, { useEffect, useState } from 'react';
import { InputText, InputTextProps } from './InputText';
import { cleanDocument, isCpf } from '@utils/inputValidation';

export type InputDocumentProps = InputTextProps;

const resolveDocumentType = (document: string) =>
  isCpf(document) ? 'CPF' : 'CNPJ';

const InputDocument = (props: InputDocumentProps) => {
  const documentValue = props.control._formValues[props.name];
  const initialDocumentType = resolveDocumentType(documentValue);
  const [documentType, setDocumentType] = useState(initialDocumentType);

  const handleDocumentChange: InputTextProps['onChangeCallback'] = (event) => {
    const document = cleanDocument(event.target.value);
    setDocumentType(resolveDocumentType(document));

    props.onChangeCallback?.(event);
  };

  useEffect(() => {
    setDocumentType(resolveDocumentType(props.defaultValue || documentValue));
  }, [documentValue]);

  // O CNPJ pode ser alfanumérico nas 12 primeiras posições (placeholder '*'),
  // mantendo os 2 dígitos verificadores numéricos ('9'). Vigência: jul/2026 (RFB).
  // A máscara de CPF também usa '*' (não '9') para não bloquear a digitação de
  // uma letra enquanto o tipo ainda está sendo detectado: a primeira letra
  // precisa ser aceita para que `isCpf` reconheça um CNPJ e a máscara troque.
  // A validação (Zod) continua garantindo que o CPF seja numérico.
  const dynamicMask =
    documentType === 'CPF' ? '***.***.***-******' : '**.***.***/****-99';

  return (
    <InputText
      {...props}
      mask={dynamicMask}
      onChangeCallback={handleDocumentChange}
      transformValue={(value) => value.toUpperCase()}
    />
  );
};

export default InputDocument;
